<template>
  <div>
    <div>
      <div class="box">
        <!-- change name -->
        <div class="field has-text-left">
          <p class="label">{{ $t('popup.upload_sheet.name') }}</p>
          <div class="control">
            <input
              v-model="editSheetName"
              name="NAME"
              class="input"
              type="text"
              :placeholder="$t('popup.upload_sheet.name')"
            />
          </div>
        </div>
        <!-- image visible à l'écran -->
        <img
          style="margin-top:10px;"
          class="columns"
          v-if="this.url_image && !listeDeroulante_url && !this.file"
          :src="this.url_image"
          width="180px"
        />
        <hr v-if="url_image && this.delete === false" />
        <div class="field has-text-left">
          <!-- ajout de templates -->
          <label class="label">
            {{ $t('board.creation.label.template') }}
            <span v-if="responseGetTemplate.owner_id===null">
              <a
                :href="racineMedia + '' + responseGetTemplate.url"
                target="_blank"
              >{{ $t('board.creation.label.voir') }}</a>
            </span>
          </label>
          <b-field>
            <b-select
              v-model="listeDeroulante_url"
              :placeholder="responseGetTemplate.owner_id===null?responseGetTemplate.name:''"
            >
              <option
                v-for="item in templates"
                :value="item.url"
                :key="item.id"
              >{{ item.name }}</option>
            </b-select>
          </b-field>
          <!-- possibilité de changer l'image -->
          <div
            style="margin-top:1em"
            class="has-text-left"
          >
            <div>
              <label class="label">
                {{ $t('board.creation.label.upload') }}
                <span v-if="responseGetTemplate.owner_id!==null && current.sheets[index].template!==null">
                  <a
                    :href="responseGetTemplate ? racineMedia + '' + responseGetTemplate.url : racineMedia + '' + current.sheets[index].url"
                    target="_blank"
                  >{{ $t('board.creation.label.voir') }}</a>
                </span>
              </label>
            </div>
            <b-upload
              v-if="!background"
              class="upload"
              accept="image/png, image/gif, image/jpeg, video/mp4"
              v-model="file"
              input
            >
              <span style="cursor:pointer;">
                <b-icon
                  pack="fas"
                  icon="image"
                ></b-icon>
                {{ $t('popup.upload_sheet.image') }}
              </span>
            </b-upload>
            <!-- supprime l'image ou affiche le nom de l'image -->
            <div
              v-if=" responseGetTemplate.owner_id || background"
              style="font-size:.8em; margin-top:10px"
            >
              <b-icon
                pack="fas"
                icon="check-square"
                size="is-small"
              ></b-icon>
              <span v-if="responseGetTemplate.owner_id!==null">{{responseGetTemplate.name}}</span>
              <span v-if="background">{{background.name}}</span>
              <span @click="deleteBackground()">
                <b-icon
                  class="is-pulled-right"
                  pack="fas"
                  icon="trash-alt"
                  size="is-small"
                ></b-icon>
              </span>
            </div>
          </div>
        </div>
        <!-- supprime sheet (affiche si feuille > 1) -->
        <div
          v-if="current.sheets.length>1"
          class="field has-text-left"
        >
          <hr />
          <p class="label">{{ $t('popup.upload_sheet.delete') }}</p>
          <div style="color:red; cursor:pointer">
            <div @click="deleteSheetButton(current.sheets[index].id); $parent.close();">
              <b-icon
                pack="fas"
                icon="trash-alt"
                size="is-small"
              ></b-icon>
              {{$t('popup.upload_sheet.delete.definitif')}}{{' '}}"{{current.sheets[index].name}}"
            </div>
          </div>
        </div>
        <hr />
        <!-- valider ou annuler -->
        <div style="display: inline;">
          <button
            @click="EditValues(); $parent.close();"
            class="button is-primary"
          >{{ $t('button.enregistrer') }}</button>
          <button
            position="left"
            class="button "
            @click="$parent.close()"
          >{{ $t('button.annuler') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import EventBus from '../../../EventBus'
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('board')
const { mapGetters } = createNamespacedHelpers('board')
export default {
  props: {
    index: Number,
    required: true
  },
  data () {
    return {
      racineMedia: process.env.URL_MEDIA,
      file: null,
      errors: [],
      url_media: process.env.URL_MEDIA,
      editSheetName: '',
      uploadSheet: null,
      background: null,
      delete: false,
      url_image: null,
      listeDeroulante_url: null,
      responseGetTemplate: [],
      urlCurrentBad: false,
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      current: 'current',
      currentSheet: 'currentSheet',
      templates: 'templates',
      url_moderateur: 'url_moderateur'
    }),
    ...mapGetters({
      getCurrent: 'getCurrent'
    })
  },
  watch: {
    isLoading: {
      handler: function () {
        this.responseGetTemplate.name = ''
        this.getBackground(this.currentSheet)
      }
    },
    file: {
      handler: function (val) {
        if (this.file !== null) {
          this.postBackground()
        }
      }
    },
    listeDeroulante_url: {
      handler: function () {
        this.backgroundAffiche()
      }
    }
  },
  created () {
    this.sendNameSheet()
    this.backgroundAffiche()
    this.getBackground()
    this.$store.dispatch('board/getTemplates', this.url_moderateur)
  },
  methods: {
    // permet d'afficher le bon background (soit le bg de la board, soit le bg de la sheet (bg liste déroulante ou bg image))
    backgroundAffiche () {
      if (this.listeDeroulante_url) {
        this.url_image = this.url_media + this.listeDeroulante_url
      } else if (this.current.sheets[this.index].url) {
        this.url_image = this.url_media + this.current.sheets[this.index].url
        // data du background
      } else {
        if (this.current.template !== null) {
          this.url_image = this.url_media + this.current.template.url
        }
      }
    },
    // permet de récupérer le nom de la feuille
    sendNameSheet () {
      this.editSheetName = this.current.sheets[this.index].name
    },
    /// // TEMPLATE /////
    // get
    async getBackground () {
      let urlCurrent = ''
      if (this.current.template !== null) {
        urlCurrent = this.current.template.url
      } else {
        this.urlCurrentBad = true
        urlCurrent = '35d9463d-effb-4cb6-9cb6-e3bd440bcf50.png'
      }
      // on supprime "uploads/brainstorming/templates/" avec substring()
      let url =
        this.current.sheets[this.index].url !== null
          ? this.current.sheets[this.index].url.substring(32)
          : urlCurrent.substring(32)
      let res = await fetch(
        `${process.env.URL_SSO_API}brainstorming/public/template/${url}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            urlmoderateur: this.current.url_moderateur
          }
        }
      )
      let data = await res.json()
      if (data[0]) {
        this.responseGetTemplate = data[0]
        this.url_image = this.url_media + data[0].url
      }
    },
    // post
    async postBackground () {
      this.isLoading = true
      const formvalues = new FormData()
      formvalues.append('file', this.file)
      formvalues.append('name', this.file.name)
      let res = await fetch(
        `${process.env.URL_SSO_API}brainstorming/public/template/${this.getCurrent.owner_id}`,
        {
          method: 'POST',
          headers: {
            urlmoderateur: this.current.url_moderateur
          },
          body: formvalues
        }
      )
      let data = await res.json()
      this.background = data
      this.url_image = this.url_media + data.url
      this.isLoading = false
    },
    // delete
    async deleteBackground () {
      this.delete = true
      this.responseGetTemplate = []
      this.background = null
      this.url_image = null
      if (this.current.sheets[this.index].url !== null) {
        // on supprime "uploads/brainstorming/templates/" avec substring()
        let res = await fetch(
          `${
          process.env.URL_SSO_API
          }brainstorming/public/template/${this.current.sheets[
            this.index
          ].url.substring(32)}`,
          {
            method: 'DELETE',
            headers: {
              urlmoderateur: this.current.url_moderateur
            }
          }
        )
        await res
      }
    },
    // on update la feuille avec un emit
    EditValues () {
      let url = ''
      // cas j'ai pas de background du tout
      if (
        this.getCurrent.template !== null &&
        this.current.sheets[this.index].url === null &&
        this.background === null &&
        this.listeDeroulante_url === null
      ) {
        url = this.getCurrent.template.url
      }
      // cas je choisis dans la liste déroulante
      if (this.listeDeroulante_url !== null) {
        url = this.listeDeroulante_url
      }
      //
      if (
        this.getCurrent.template === null &&
        this.background === null &&
        this.listeDeroulante_url === null
      ) {
        url = this.current.sheets[this.index].url
      }
      if (this.background !== null && this.listeDeroulante_url === null) {
        url = this.background.url
      }
      if (
        this.getCurrent.template !== null &&
        this.current.sheets[this.index].url !== null &&
        this.background === null &&
        this.listeDeroulante_url === null && this.delete === false
      ) {
        url = this.current.sheets[this.index].url
      }
      // on upload la feuille avec ses nouvelles valeurs
      this.uploadSheet = {
        name: this.editSheetName,
        id: this.currentSheet,
        url: url
      }
      // si on supprime le background, on affiche le bg general en passant sa valeur a null
      if (
        this.listeDeroulante_url === null &&
        this.delete === true &&
        this.background === null
      ) {
        this.uploadSheet = {
          name: this.editSheetName,
          id: this.currentSheet,
          url: null
        }
      }
      this.$store.commit('board/UPDATE_SHEET', {
        name: this.uploadSheet.name,
        id: this.uploadSheet.id,
        url: this.uploadSheet.url
      })
      this.$store.dispatch('board/updateSheet', {
        board: this.current,
        sheet: {
          name: this.uploadSheet.name,
          id: this.uploadSheet.id,
          url: this.uploadSheet.url
        }
      })
      this.$buefy.toast.open({
        type: 'is-success',
        message: this.$i18n.t('toast.modification.success')
      })
      EventBus.$emit('UPLOAD_SHEET', this.currentSheet)
    },
    // supprimer une feuille
    deleteSheetButton (id) {
      this.$buefy.dialog.confirm({
        cancelText: this.$i18n.t('button.annuler'),
        confirmText: this.$i18n.t('button.supprimer'),
        message: this.$i18n.t('sheet.supprimer.message'),
        onConfirm: () => this.deletesheet(id)
      })
    },
    deletesheet (id) {
      this.$store.dispatch('board/deleteSheet', {
        board: this.current,
        sheet: id
      })
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: 0.4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.modal-content {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/board/modal/updateSheetPopup.vue